<sdps-modal-beta [attr.sdps-title]="isSloa ? titleSloa : titleTxn" id="delete-draft-modal">
    <div slot="modal-body">
        <div class="sdps-text-body modal-first-line" class="delete-draft-modal-messaging">{{isSloa ? textBodySloa : textBodyTxn}}</div>
        <div class="sdps-text-body" *ngIf="!isSloa"><strong>Process date: </strong>{{currentDraft?.['Process date']}}</div>
        <div class="sdps-text-body"><strong>Initiation date: </strong>{{currentDraft?.['Initiation date']}}</div>
        <div class="sdps-text-body"><strong>Initiator ID: </strong>{{currentDraft?.['Initiator ID']}}</div>
        <div class="sdps-text-body" *ngIf="!isSloa"><strong>Amount: </strong>{{currentDraft?.Amount}}</div>
        <div class="sdps-text-body"><strong>Type: </strong>{{currentDraft?.Type}}</div>
    </div>
    <div slot="modal-footer">
        <button (click)="onBackClick()" type="button"
        class="sdps-button sdps-button--small sdps-button--secondary">Back</button>
        <button (click)="onDeleteTemplateClick()" type="button"
        class="sdps-button sdps-button--primary sdps-button--small" id="lc_cancel_continue">{{isSloa ? 'Yes, Delete' : 'Yes, Cancel'}}</button>
    </div>
</sdps-modal-beta>